import R from 'ramda';
import gql from 'graphql-tag';
import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import moment from 'moment';
import { Component } from 'react';
import { fromGlobalId } from 'graphql-relay';
import { graphql } from 'react-apollo';

import Button from '../Button';
import Card from '../Card';
import Container from '../Container';
import Footer from '../Footer';
import Grid from '../Grid';
import Header from '../Header';
import HeroText from '../HeroText';
import ImageTestimonial from '../ImageTestimonial';
import Schedule from '../Schedule';
import FoodSection from '../FoodSection';
import Search from '../Search';
import SectionHeader from '../SectionHeader';
import Video from '../Video';
import TeachersGrid from '../TeachersGrid';

import profileImage from '../images/profile.jpg';
import rowOfStudents from '../images/row-of-students.jpg';

import styles from './html-and-css.css';

import anneImg from '../images/teacher-anne.jpg';
import hamzahImg from '../images/teacher-hamzah.jpg';
import jasonImg from '../images/teacher-nosaj.jpg';

const teachers = [
    {
        name: 'Anne Ganzeboom',
        bio: 'Anne is a hands-on digital designer and front-end developer with a passion for creating web applications with beautiful UX and UI that are well-thought-out - blending technology and creativity. Anne’s students have built some of the best designed sites we’ve ever seen. (put her first in list- female empowerment)',
        image: anneImg,
        role: 'Digital Designer & Front-end developer'
    },
    {
        name: 'Hamzah',
        bio: 'Hamzah is a software engineer at Cytora; one of London’s fastest growing startups. At university Hamzah studied French and Arabic before going on to study Software Engineering in California. Hamzah is a big proponent of developing an engineer’s mindset and fosters this approach in all of his classes. ',
        image: hamzahImg,
        role: 'Software Engineer, Cytora'
    },
    {
        name: 'Jason Howmans',
        bio: 'Jason is a passionate teacher and a one man startup machine - with a record of designing and building a huge range of websites from scratch, including William Hill Online, Utility Warehouse, and applications for the BBC. Jason has a broad interests that he loves speaking about with students - grab him at lunch.',
        image: jasonImg,
        role: 'Designer & Developer'
    }
];

class HtmlAndCss extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: this.props.query
        };
    }

    render() {
        const {
            isOpen,
            course,
            courses
        } = this.props;

        const { div, p, br } = hh(h);

        const detailCards = [
            {
                headerText: 'You’ll create',
                bodyText: 'Your own website for the whole world to see, all in a weekend.',
                theme: 'two'
            },
            {
                headerText: 'You’ll learn',
                bodyList: [
                    'What HTML and CSS are',
                    'How the web works',
                    'How to solve problems using tech'
                ],
                theme: 'two'
            },
            {
                headerText: 'You’ll leave with',
                bodyText: 'The power to build websites, a community of peers committed to learning to code and a hard skill to impress prospective employers.',
                theme: 'two'
            }
        ];

        const schedules = [
            {
                title: 'Saturday',
                schedule: [
                    {
                        startTime: '10:00',
                        endTime: '12:30',
                        bodyText: 'Start learning how websites work and write your first lines of code!',
                        theme: 'two'
                    },
                    {
                        startTime: '12:30',
                        endTime: '13:30',
                        bodyText: 'Take a lunch break, meet new friends and get excited for the next few hours!',
                        theme: 'two'
                    },
                    {
                        startTime: '13:30',
                        endTime: '17:00',
                        bodyText: 'Build on your knowledge of HTML by learning CSS - the language that will make your website beautiful!',
                        theme: 'two'
                    }
                ]
            },
            {
                title: 'Sunday',
                schedule: [
                    {
                        startTime: '10:00',
                        endTime: '12:30',
                        bodyText: 'You’ve slept well and you’re ready to start building your own personalised website! That’s right, by the end of the weekend you’ll have built your own live site.',
                        theme: 'two'
                    },
                    {
                        startTime: '12:30',
                        endTime: '13:30',
                        bodyText: 'Take a lunch break, meet even more new friends or become best friends with the people from yesterday!',
                        theme: 'two'
                    },
                    {
                        startTime: '13:30',
                        endTime: '17:00',
                        bodyText: 'You’ll keep working on your site, work with the instructors to improve it, learn how to host it online and dip into some Javascript if you’re up for the challenge.',
                        theme: 'two'
                    }
                ]
            }
        ];

        const openApplyButton = (course) => (
          div({className: styles.applyButtonContainer},
              h(Button, {href: `/course/${fromGlobalId(course.id).id}`, arrow: true, arrowPosition: 'front', theme: 'white', size: 'big'}, 'Apply now')
             )
        );

        const closedApplyButton = (course) => (
            div(
                {
                    className: styles.applyButtonContainer
                },
                [
                    p({ className: styles.applyHelp }, [
                        'Hang tight! Applications for the course at ',
                        br(),
                        `${course.university.name} for ${moment(new Date(course.startDate)).format('MMM Do')}—${moment(new Date(course.endDate)).format('MMM Do')} `,
                        br(),
                        'will open soon.'])
                ])
        );

        const HtmlSearch = graphql((gql`
    query{
        courses(where: { published: true, type: "html" }) {
            id
            name
            description
            level
            startDate
            endDate
            state
            tbd
            type

            university {
              name
              shortName
            }
        }
    }
`))(Search);

        const applyButton = (isOpen, course) => {
            if (R.isNil(course)) {
                throw new Error('`course` cannot be `null`');
            }

            return isOpen ? openApplyButton(course) : closedApplyButton(course);
        };

        const cta = ({isOpen, course, courses}) => {
            if (R.isNil(course)) {
                return div({className: styles.searchContainer}, [
                    h(HtmlSearch, {placeholder: 'e.g. University College London', helpText: 'Search for your uni to find an HTML & CSS course', query: this.state.query})]);
            } else {
                return applyButton(isOpen, course);
            }
        };

        return (
            div({className: styles.container}, [
                h(Header),
                h(Container, {theme: 'two', size: 'big'}, [
                    div({className: styles.heroContainer}, [
                        h(HeroText, {subText: 'Learn the foundations of web development by building your own website.'}, 'HTML and CSS'),
                        cta({isOpen, course, courses})
                    ])
                ]),
                h(Container, {size: 'big', theme: 'neutral'}, [
                    h(SectionHeader, 'How to get started'),
                    h(Video, {src: 'https://www.youtube.com/embed/hsHN1CjAo6A'})
                ]),
                h(Container, {size: 'big'}, [
                    h(SectionHeader, 'What our graduates say'),
                    h(ImageTestimonial, {
                        image: rowOfStudents,
                        quote: 'I plan to study an MSc in Computer Science and I felt like this course was the perfect taster to code.',
                        author: 'HTML & CSS graduate',
                        authorDetail: 'University College London',
                        theme: 'two'
                    }),
                    h(ImageTestimonial, {
                        image: profileImage,
                        quote: 'The teaching at Code at Uni was fantastic and I was able to build an application that helps you optimise your sleeping patterns!',
                        author: 'Mai',
                        authorDetail: 'BSc Economics, London School of Economics',
                        side: 'right',
                        theme: 'two'
                    })]),
                h(Container, {size: 'big', theme: 'neutral'}, [
                    h(SectionHeader, 'Details'),
                    h(Grid, R.map((props) => h(Card, props), detailCards))]),
                h(FoodSection),
                h(Container, {size: 'big'}, [
                    h(SectionHeader, {theme: 'two'}, 'Schedule'),
                    h(Schedule, {schedules})]),
                h(Container, { theme: 'neutral' }, [
                    h(SectionHeader, 'Your instructors'), 
                    h(TeachersGrid, { teachers })
                ]),
                h(Container, [
                    h(Footer)])])
        );
    };
};

export default HtmlAndCss;



/** WEBPACK FOOTER **
 ** ./src/HtmlAndCss/index.js
 **/